import { ReactNode } from 'react'
import { z } from 'zod'

export const assetDBSearchSchema = z.object({
  // Individual filter parameters
  asset: z.string().optional(),
  lastInspectionDate: z.array(z.string()).optional(),
  lastUpdated: z.array(z.string()).optional(),
  unitComponents: z.array(z.number().nullable()).optional(),
  area: z.string().optional(),
  areaDescription: z.string().optional(),
  erpId: z.string().optional(),
  criticality: z.string().optional(),
  search: z.string().optional(),
})

export type AssetDBSearchParams = z.infer<typeof assetDBSearchSchema>

/**
 * A change parsed from the audit log for an entry
 * @param key - The key of the change
 * @param title - The displayable title of the change
 * @param body - The displayable body of the change
 * @param data - Relevant data for other components to consume the activity
 */
export interface Activity {
  key: string
  title: ReactNode
  body: ReactNode
  data?: Record<string, unknown>
}
